"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _marketActivity = require("@/api/marketActivity");
var marketApi = _interopRequireWildcard(require("@/api/market"));
var _ActivityDetail = _interopRequireDefault(require("@/components/ActivityDetail"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'ActivityList',
  components: {
    ActivityDetail: _ActivityDetail.default
  },
  data: function data() {
    return {
      collapse: false,
      labelPosition: 'right',
      listLoading: false,
      tableHeight: 0,
      searchForm: {
        activityName: '',
        marketId: '',
        status: '',
        processStatus: '',
        dateRange: []
      },
      tableFrom: {
        page: 1,
        limit: 10,
        activityName: '',
        marketId: '',
        status: '',
        processStatus: '',
        form: '',
        to: ''
      },
      tableData: {
        data: [],
        total: 0
      },
      // 详情相关
      detailDrawerVisible: false,
      detailLoading: false,
      currentActivityDetail: null,
      // 集市搜索相关
      marketLoading: false,
      marketOptions: [],
      // 取消活动相关
      cancelDialogVisible: false,
      cancelForm: {
        id: null,
        cancelRemark: ''
      }
    };
  },
  created: function created() {
    this.initList();
  },
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      _this.calculateTableHeight();
    });
    window.addEventListener('resize', this.calculateTableHeight);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.calculateTableHeight);
  },
  methods: {
    /**
     * 解析图片数据
     */
    parseImageData: function parseImageData(imageData) {
      if (!imageData) return [];
      try {
        // 如果是JSON字符串，解析为数组
        if (typeof imageData === 'string') {
          var parsed = JSON.parse(imageData);
          return Array.isArray(parsed) ? parsed : [];
        }
        // 如果是数组，直接返回
        if (Array.isArray(imageData)) {
          return imageData;
        }
        // 如果是逗号分隔的字符串，分割为数组
        if (typeof imageData === 'string' && imageData.includes(',')) {
          return imageData.split(',').filter(function (img) {
            return img.trim();
          });
        }
        return [];
      } catch (error) {
        console.error('解析图片数据失败:', error);
        return [];
      }
    },
    /**
     * 获取第一张图片
     */
    getFirstImage: function getFirstImage(imageData) {
      var images = this.parseImageData(imageData);
      return images.length > 0 ? images[0] : '';
    },
    /**
     * 解析图片列表用于预览
     */
    parseImageList: function parseImageList(imageData) {
      return this.parseImageData(imageData);
    },
    // 初始化列表
    initList: function initList() {
      var _this2 = this;
      this.listLoading = true;
      (0, _marketActivity.marketActivityList)(this.tableFrom).then(function (res) {
        console.log('活动列表数据:', res);
        _this2.tableData.data = res.list || [];
        _this2.tableData.total = res.total || 0;
        _this2.listLoading = false;
      }).catch(function (err) {
        console.error('获取活动列表失败:', err);
        _this2.tableData.data = [];
        _this2.tableData.total = 0;
        _this2.listLoading = false;
        _this2.$message.error('获取活动列表失败');
      });
    },
    // 搜索
    handleSearchList: function handleSearchList() {
      this.tableFrom.page = 1;
      this.tableFrom.activityName = this.searchForm.activityName;
      this.tableFrom.marketId = this.searchForm.marketId;
      this.tableFrom.status = this.searchForm.status;
      this.tableFrom.processStatus = this.searchForm.processStatus;

      // 处理时间范围
      if (this.searchForm.dateRange && this.searchForm.dateRange.length === 2) {
        this.tableFrom.form = this.searchForm.dateRange[0];
        this.tableFrom.to = this.searchForm.dateRange[1];
      } else {
        this.tableFrom.form = '';
        this.tableFrom.to = '';
      }
      this.initList();
    },
    // 重置搜索
    handleReset: function handleReset(formName) {
      // 重置表单字段
      this.$refs[formName].resetFields();
      // 重置搜索表单数据
      this.searchForm = {
        activityName: '',
        marketId: '',
        status: '',
        processStatus: '',
        dateRange: []
      };
      // 重置查询参数
      this.tableFrom.page = 1;
      this.tableFrom.activityName = '';
      this.tableFrom.marketId = '';
      this.tableFrom.status = '';
      this.tableFrom.processStatus = '';
      this.tableFrom.form = '';
      this.tableFrom.to = '';
      // 重新加载列表
      this.initList();
    },
    // 新增
    handleAdd: function handleAdd() {
      this.$router.push({
        path: '/market/activity/add'
      });
    },
    // 编辑
    handleEdit: function handleEdit(row) {
      this.$router.push({
        path: '/market/activity/add',
        query: {
          id: row.id
        }
      });
    },
    // 添加报名（仅上架活动展示，跳转并预选当前活动）
    handleAddApply: function handleAddApply(row) {
      this.$router.push({
        path: '/market/activity/apply/add',
        query: {
          activityId: row.id
        }
      });
    },
    // 上架
    handlePublish: function handlePublish(row) {
      var _this3 = this;
      this.$modal.confirm('确认上架该活动吗？').then(function () {
        (0, _marketActivity.marketActivityPublish)({
          id: row.id
        }).then(function () {
          _this3.$message.success('上架成功');
          _this3.initList();
        }).catch(function (err) {
          _this3.$message.error('上架失败');
        });
      });
    },
    // 下架
    handlePullDown: function handlePullDown(row) {
      var _this4 = this;
      this.$modal.confirm('确认下架该活动吗？').then(function () {
        (0, _marketActivity.marketActivityPullDown)({
          id: row.id
        }).then(function () {
          _this4.$message.success('下架成功');
          _this4.initList();
        }).catch(function (err) {
          _this4.$message.error('下架失败');
        });
      });
    },
    // 取消活动
    handleCancel: function handleCancel(row) {
      this.cancelForm.id = row.id;
      this.cancelForm.cancelRemark = '';
      this.cancelDialogVisible = true;
    },
    // 确认取消活动
    confirmCancel: function confirmCancel() {
      var _this5 = this;
      if (!this.cancelForm.cancelRemark.trim()) {
        this.$message.warning('请输入取消备注');
        return;
      }
      (0, _marketActivity.marketActivityCancel)({
        id: this.cancelForm.id,
        cancelRemark: this.cancelForm.cancelRemark
      }).then(function () {
        _this5.$message.success('取消成功');
        _this5.cancelDialogVisible = false;
        _this5.initList();
      }).catch(function (err) {
        _this5.$message.error('取消失败');
      });
    },
    // 关闭取消对话框
    closeCancelDialog: function closeCancelDialog() {
      this.cancelDialogVisible = false;
      this.cancelForm.id = null;
      this.cancelForm.cancelRemark = '';
    },
    // 删除
    handleDelete: function handleDelete(row) {
      var _this6 = this;
      this.$modal.confirm('确认删除该活动吗？删除后不可恢复！').then(function () {
        (0, _marketActivity.marketActivityDelete)(row.id).then(function () {
          _this6.$message.success('删除成功');
          _this6.initList();
        }).catch(function (err) {
          _this6.$message.error('删除失败');
        });
      });
    },
    // 分页大小改变
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.initList();
    },
    // 页码改变
    handleCurrentChange: function handleCurrentChange(val) {
      this.tableFrom.page = val;
      this.initList();
    },
    // 获取进程状态名称
    getProcessStatusName: function getProcessStatusName(processStatus) {
      var statusMap = {
        0: '未开始',
        1: '进行中',
        2: '已结束',
        3: '已取消'
      };
      return statusMap[processStatus] || '未知';
    },
    // 获取进程状态标签类型
    getProcessStatusType: function getProcessStatusType(processStatus) {
      var typeMap = {
        0: 'info',
        1: 'success',
        2: 'warning',
        3: 'danger'
      };
      return typeMap[processStatus] || 'info';
    },
    // 计算表格高度
    calculateTableHeight: function calculateTableHeight() {
      var _this7 = this;
      this.$nextTick(function () {
        var windowHeight = window.innerHeight;
        var headerHeight = _this7.$refs.tableheader ? _this7.$refs.tableheader.offsetHeight : 0;
        var paginationHeight = 60;
        var otherHeight = 200;
        _this7.tableHeight = windowHeight - headerHeight - paginationHeight - otherHeight;
      });
    },
    // 查看详情
    handleDetail: function handleDetail(row) {
      var _this8 = this;
      this.detailDrawerVisible = true;
      this.detailLoading = true;
      this.currentActivityDetail = null;
      (0, _marketActivity.marketActivityInfo)(row.id).then(function (res) {
        console.log('活动详情数据:', res);
        _this8.currentActivityDetail = _objectSpread(_objectSpread({}, res), {}, {
          timeRemark: res && res.timeRemark ? res.timeRemark : '',
          bulletScreen: res && res.bulletScreen ? res.bulletScreen : ''
        });
        _this8.detailLoading = false;
      }).catch(function (err) {
        console.error('获取活动详情失败:', err);
        _this8.$message.error('获取活动详情失败');
        _this8.detailLoading = false;
      });
    },
    // 关闭详情抽屉
    handleDetailClose: function handleDetailClose() {
      this.detailDrawerVisible = false;
      this.currentActivityDetail = null;
    },
    /**
     * 搜索集市
     */
    searchMarkets: function searchMarkets(query) {
      var _this9 = this;
      if (query !== '') {
        this.marketLoading = true;
        marketApi.marketList({
          marketName: query,
          page: 1,
          limit: 20
        }).then(function (res) {
          _this9.marketOptions = res.list || [];
          _this9.marketLoading = false;
        }).catch(function () {
          _this9.marketLoading = false;
        });
      } else {
        // 当查询为空时，清空选项列表
        this.marketOptions = [];
      }
    },
    /**
     * 加载默认集市
     */
    loadDefaultMarkets: function loadDefaultMarkets() {
      var _this0 = this;
      marketApi.marketList({
        page: 1,
        limit: 20
      }).then(function (res) {
        _this0.marketOptions = res.list || [];
      });
    }
  }
};